module.exports = {
    baseURL: (function(){
        if (process.env.NODE_ENV === 'development') {
            return 'https://akx.dev.boogcloud.com/akx/bubu'
        } else if (process.env.NODE_ENV === 'production') {
            return 'https://ai.kxkx888.com/aikuaixiao/bubu'
        }
    })()
}